import React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import StarIcon from '@mui/icons-material/Star';
import { Hidden } from '@mui/material';
import { makeStyles } from '@mui/material';
import { blue } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import { useState } from 'react';
import { useUserAuth } from '../context/UserAuthContext';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router';
import Footer from '../components/Footer';

export default function Signup() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const {signUp} = useUserAuth();
    const [error, setError] = useState("");
    const navigate = useNavigate();
  
    const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
        await signUp(email, password);
        navigate("/alljobs");
    } catch (err) {
        setError(err.message);
    }

  };

  return (
         <CssBaseline>     
      <Grid container component="main" 
        sx={{ 
          height: '90vh', 
          bgcolor: "green", 
          backgroundImage: 'url(https://jobsandlaw.com/wp-content/uploads/2018/11/torres-1670879_1920.jpg)',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat', }}>
            
      <Grid item xs={6} sm={6} md={6} square>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: "flex-end",
              justifyContent: "center",
              bgcolor: 'rgba(43, 117, 177, 0.9)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              height: '90vh',
              paddingRight: "10%",

            }}
          >
              <Typography variant="h2" 
              sx={{color: "white", fontWeight: "bold", textAlign: "right"}}
              >Empleo de calidad
            </Typography>
            <Typography variant="h2" 
              sx={{color: "white", fontWeight: "bold", textAlign: "right" }}
              >para abogados
            </Typography>
            <Typography variant="h4" 
              sx={{paddingTop: "50px", color: "white", fontWeight: "bold", textAlign: "right" }}
              >Accede a todas las vacantes
            </Typography>
            <Typography variant="h4" 
              sx={{color: "white", fontWeight: "bold", textAlign: "right" }}
              >abiertas por despachos,
            </Typography>
            <Typography variant="h4" 
              sx={{color: "white", fontWeight: "bold", textAlign: "right" }}
              >empresas y headhunters
            </Typography>
            </Box>
            </Grid>

        <Grid item xs={6} sm={6} md={6} square>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: "center",
              alignItems: "flex-start",
              paddingLeft: "10%",
              bgcolor: 'rgba(43, 117, 177, 0.9)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              height: '90vh',
            }}
          >
            <Box component="form" noValidate onSubmit={handleSubmit} sx={{mt: 1, color: "white", bgcolor: "rgba(228, 237, 246, 0.17)", marginTop: "60px", marginBottom: "60px", borderRadius: "25px", padding: "20px", maxWidth: "450px" }}>
            <Typography variant="h6" 
                sx={{paddingTop: "10px", color: "white", textAlign: "center"}}
                >Empleo de calidad para abogados</Typography>
            <Typography component="h5" variant="subtitle" sx={{color: "whitesmoke", textAlign: "center", padding: "0px 40px 20px 20px"}}>
              Accede a todas las vacantes abiertas por despachos, empresas y headhunters
            </Typography>
            <Typography component="h1" variant="h6" sx={{color: "whitesmoke", textAlign: "center"}}>
              Regístrate gratis
            </Typography>
            <Divider>
            <Chip label="Con tus redes sociales" sx={{color: "white"}} />
            </Divider>
            {error &&     <Stack sx={{ width: '100%' }} spacing={2}>
            <Alert severity="error">Datos incorrectos</Alert>
            </Stack>}   
              <TextField   
                sx={{input: {color: "black", backgroundColor: "whitesmoke", borderRadius: "5px"}, border: "green", color: "green"}}
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                sx={{input: {color: "whitesmoke", backgroundColor: "rgba(231, 235, 242, 0.5)", borderRadius: "5px"}, border: {color: "green"}}}
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                onChange={(e) => setPassword(e.target.value)}
              />
              <FormControlLabel
                sx={{color: "white"}}
                control={<Checkbox value="remember" color="primary"/>}
                label="Remember me"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2, backgroundColor: "rgba(43, 117, 177, 0.9)", color: "white"}}

              >
                Registrarse
              </Button>
              <Grid container>
                <Grid item xs>
                  <Link href="#" variant="body2" sx={{color: "white"}} >
                    Forgot password?
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="#" variant="body2" sx={{color: "white"}}>
                    {"Don't have an account? Sign Up"}
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </CssBaseline>   
  );
}
